import { Box, Typography } from '@mui/material';
import { getIcon } from './icons';

function ImpactMetrics({ metrics, partnerName }) {
  if (!metrics?.length) return null;

  return (
    <Box
      sx={{
        maxWidth: 720,
        mx: 'auto',
        mb: { xs: 5, sm: 7, md: 9 },
      }}
    >
      <Typography
        variant="overline"
        sx={{
          display: 'block',
          color: 'primary.main',
          letterSpacing: '0.22em',
          fontWeight: 600,
          fontSize: '0.72rem',
          mb: 0.5,
          textAlign: 'center',
        }}
      >
        Nuestra colaboración
      </Typography>
      {partnerName && (
        <Typography
          sx={{
            color: 'text.secondary',
            fontSize: '0.88rem',
            textAlign: 'center',
            mb: 2.5,
          }}
        >
          Huelmu × {partnerName}
        </Typography>
      )}
      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: {
            xs: `repeat(${Math.min(metrics.length, 2)}, 1fr)`,
            sm: `repeat(${Math.min(metrics.length, 4)}, 1fr)`,
          },
          gap: { xs: 1.5, sm: 2 },
          maxWidth: metrics.length === 1 ? 280 : '100%',
          mx: 'auto',
        }}
      >
      {metrics.map((metric, i) => {
        const Icon = getIcon(metric.icon);
        return (
          <Box
            key={i}
            sx={{
              p: { xs: 2, sm: 2.5 },
              textAlign: 'center',
              borderRadius: 3,
              backgroundColor: 'rgba(255, 255, 255, 0.55)',
              border: '1px solid rgba(74, 106, 74, 0.12)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              gap: 0.75,
            }}
          >
            <Icon size={22} color="#4a6a4a" strokeWidth={1.75} />
            <Typography
              sx={{
                fontFamily: 'var(--font-heading)',
                color: 'text.primary',
                fontSize: { xs: '1.6rem', sm: '1.9rem' },
                fontWeight: 500,
                lineHeight: 1,
              }}
            >
              {metric.value}
            </Typography>
            <Typography
              sx={{
                color: 'text.secondary',
                fontSize: { xs: '0.75rem', sm: '0.8rem' },
                lineHeight: 1.3,
              }}
            >
              {metric.label}
            </Typography>
          </Box>
        );
      })}
      </Box>
    </Box>
  );
}

export default ImpactMetrics;
